import { render, staticRenderFns } from "./TenantClientList.vue?vue&type=template&id=ed115d28&scoped=true"
import script from "./TenantClientList.vue?vue&type=script&lang=js"
export * from "./TenantClientList.vue?vue&type=script&lang=js"
import style0 from "./TenantClientList.vue?vue&type=style&index=0&id=ed115d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed115d28",
  null
  
)

export default component.exports